import { render, staticRenderFns } from "./modal_attachments.vue?vue&type=template&id=bef45be6"
import script from "./modal_attachments.vue?vue&type=script&lang=js"
export * from "./modal_attachments.vue?vue&type=script&lang=js"
import style0 from "./modal_attachments.vue?vue&type=style&index=0&id=bef45be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports